/**
 * Constants and configuration for Expression of Interest Modal
 */

import { MatDialogConfig } from '@angular/material/dialog';

export const EOI_MODAL_CONFIG: MatDialogConfig = {
  width: '960px',
  maxWidth: '96vw',
  maxHeight: '92vh',
  panelClass: 'eoi-dialog-panel',
  autoFocus: false,
  disableClose: false,
};

export const EOI_MODAL_MESSAGES = {
  header: {
    title: 'Expression of Interest',
    subtitle: 'Start your licensing journey, no account required.'
  },
  info: {
    description: 'Once reviewed, you will receive an email with a link to schedule your appointment with the VF Team.'
  },
  success: {
    title: 'Interest Submitted!',
    leadTextBefore: 'Thank you. Your Expression of Interest has been received and is',
    statusBadge: 'Pending Review',
    subText: 'An email will be sent to {{email}} with a link to schedule your appointment once your EOI is approved.'
  },
  form: {
    referenceNumber: 'EOI'
  }
} as const;